import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'lib-wizard',
	templateUrl: './wizard.component.html',
	styleUrls: ['./wizard.component.scss'],
})
export class WizardComponent implements OnInit {
	@Input() positionWizard: number = 1;
	@Input() dataWizard: string[] = [];

	constructor() {}

	ngOnInit(): void {}
}
